import * as React from "react";

import { UnitLayoutingContext, UnitLayoutingContextProvider } from "./Internals/UnitBorderContext/UnitLayoutingContext";
import { UnitIdProvider } from "./UnitIdContext";
import { UnitId } from "./UnitId/UnitId";

interface SimpleFormUnitProps {
    id: UnitId;
    children: React.ReactNode;
}

const plainUnitLayoutingContext: UnitLayoutingContext = {
    paddingRight: 40,
    paddingLeft: 40,
};

export function PlainFormUnit(props: SimpleFormUnitProps): JSX.Element {
    return (
        <UnitIdProvider id={props.id}>
            <UnitLayoutingContextProvider value={plainUnitLayoutingContext}>
                {props.children}
            </UnitLayoutingContextProvider>
        </UnitIdProvider>
    );
}
